<div *ngIf="loading">Carregando contas...</div>
<table *ngIf="!loading" class="table">
    <thead>
        <tr>
            <th>Instagram ID</th>
            <th>Tipo</th>
            <th>Expira em</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let acc of accounts">
            <td>{{ acc.instagram_user_id }}</td>
            <td>{{ acc.account_type }}</td>
            <td>{{ acc.expires_at | date:'short' }}</td>
            <td>
                <button (click)="remove(acc)">Remover</button>
            </td>
        </tr>
    </tbody>
</table>